import { TenantEntity } from '../entity';


export interface UoM extends TenantEntity {
    type: 'Time' | 'Length' | 'Area' | 'Volume' | 'Weight' | 'Count'
    name: string;
    abbreviation: string;
    wholeNumber: boolean;
    active: boolean;

}

export interface CodeUoM {
    _id?: string;
    uom: UoM;
    conversionRate: number;
    group?: string;
}

/**
 * How a unit is spelled on a document line. `||` not `??`: an empty name falls through to the
 * abbreviation, which `??` would keep as a blank label.
 */
export function codeUoMName(codeUoM: CodeUoM | null | undefined): string | undefined {

    return codeUoM?.uom?.name || codeUoM?.uom?.abbreviation || undefined;
}

/**
 * Fills a line's denormalised `uom` string from its canonical `codeUoM`.
 *
 * Every legacy document writer set only `codeUoM`, so lines written before the v2 surfaces carry no
 * `uom` at all — a UOM column bound to `uom` then reads blank, and a revision faithfully copies that
 * blank forward. Normalising on write repairs each line the next time its document is saved instead
 * of requiring a migration. An existing `uom` is left alone: it is the value the user last chose.
 */
export function withDenormalisedUoM<TLine extends { uom?: string; codeUoM?: CodeUoM }>(line: TLine): TLine {

    if (line?.uom || !line?.codeUoM) return line;
    const name = codeUoMName(line.codeUoM);
    return name ? { ...line, uom: name } : line;
}
